import type { Rep } from '@thevillages/schemas';

import { Component, inject, input, output } from '@angular/core';

import { Environment } from '../../../../../environments/environment';
import { StateService } from '../../../../services/state/state';

@Component({
  imports: [],
  selector: 'app-listing-details-sidebar-rep',
  styleUrl: './rep.css',
  templateUrl: './rep.html',
})
export class ListingDetailsSidebarRep {
  private readonly _stateService = inject(StateService);

  public readonly rep = input.required<Rep>();
  public readonly setRepFilter = output<string>();

  public bioPostMessage(): void {
    // if (environment.isApp) {
    //   console.log('A');
    //   this.stateService.notifyParentOfStateChange('HF_EVENT:LISTING_DETAILS_REP_BIO', {
    //     repId: this.rep().id,
    //     repName: this.rep().firstName + ' ' + this.rep().lastName,
    //   });
    // }
    // else {
    const _origin = Environment.isApp ? 'https://www.thevillages.com' : '';
    const _url =
      `${_origin}/sales-reps/${this.rep().firstName.toLocaleLowerCase()}-${this.rep().lastName.toLocaleLowerCase()}/`.replaceAll(
        ' ',
        '-',
      );
    // console.log(_url);
    const _newWindow = window.open(_url, '_blank');

    if (_newWindow) {
      _newWindow.opener = null; // Add this line to prevent the new window from having access to the opener's context for security reasons
    }
    // }
  }
}
